if (process.env.REACT_APP_USE_MOCK_API) {
  module.exports = require("./enterpriseCustomerApiMock");
} else {
  module.exports = require("./enterpriseCustomerApi");
}
